import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Animated radial gradient background */}
        <div className="absolute inset-0 bg-[#121212]">
          <div
            className="absolute inset-0 animate-pulse"
            style={{
              background:
                'radial-gradient(circle at center, rgba(255, 255, 255, 0.08) 0%, rgba(18, 18, 18, 1) 70%)',
              animationDuration: '4s',
            }}
          />
        </div>

        {/* Content */}
        <div className="relative z-10 text-center px-8">
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-light text-white mb-8 tracking-[0.2em]">
            LUXAS Portfolio
          </h2>
          <p className="text-xl md:text-2xl text-white/70 font-light tracking-[0.15em]">
            Designing Trust and Light
          </p>
        </div>
      </section>
    </>
  );
}
